require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-chief-operations-officer-elected-to-credit-union-center-board.json") })
        }
      }, "path---articles-chief-operations-officer-elected-to-credit-union-center-board");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-chief-operations-officer-elected-to-credit-union-center-board!./.cache/json/articles-chief-operations-officer-elected-to-credit-union-center-board.json
// module id = 1569
// module chunks = 231608221292675